module.exports = __webpack_public_path__ + "static/media/97691843-group-of-dog-breeds-holding-bone-front-view-pet-background-banner.0face2a4.webp";